import { httpClient } from '@/services/http/httpClient'

import type {
  FinancialDetails,
  FinancialImpactTypeCreation,
} from '@/tabs/shared/financialImpact/types'

export const createFinancialImpact = async (
  finance: FinancialImpactTypeCreation,
) => {
  const { data } = await httpClient.post<FinancialDetails>(
    `/ideas/financial-details/create`,
    finance,
  )
  return data
}
